import script from "./_favorite-tickets.vue?vue&type=script&setup=true&lang=ts"
export * from "./_favorite-tickets.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__